import { render } from "./ChangePassword.vue?vue&type=template&id=4f1f8a88&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=ts"
export * from "./ChangePassword.vue?vue&type=script&lang=ts"

import "./ChangePassword.vue?vue&type=style&index=0&id=4f1f8a88&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f1f8a88"

export default script